import { apiClient } from "./ApiClient";
import { IVehicle, IContactInfo } from "../classes/Domain";

export default class QuoteApiClient {
    constructor() {

    }

    createQuote(zipCode: string, vehicle?: IVehicle | null) {
        return apiClient.instance.request({
            url: '/quote/create',
            data: {
                zipCode,
                vehicle
            }
        });
    }

    updateContactInfo(quoteUid: string, contactInfo: IContactInfo, quoteStep: string) {
        return apiClient.instance.request({
            url: '/quote/update-contact',
            data: {
                quoteUid,
                contactInfo,
                quoteStep
            }
        });
    }

    getOccupations(query: string) {
        return apiClient.instance.request({
            url: '/quote/get-occupations?query=' + query,
            method: 'get'
        });
    }

    getQuote(quoteUid: string) {
        return apiClient.instance.request({
            url: '/quote/get-quote?quoteUid=' + quoteUid,
            method: 'get'
        });
    }

    getContactInfo(quoteUid: string) {
        return apiClient.instance.request({
            url: '/quote/get-contact?quoteUid=' + quoteUid,
            method: 'get'
        });
    }

    updateQuoteAgency(quoteUid: string, producerCode: string, storeNumber: string) {
        return apiClient.instance.request({
            url: '/quote/update-quote-agency',
            data: {
                quoteUid,
                producerCode,
                storeNumber
            }
        });
    }
}